/* eslint-disable @typescript-eslint/naming-convention */
import type { Func } from "@react-awesome-query-builder/core";

const UNIFIED_YEARS_BETWEEN: Func = {
  label: "YEARS TILL DATE",
  returnType: "number",

  // Custom jsonLogic builder
  jsonLogic: (args) => ({
    UNIFIED_YEARS_BETWEEN: [
      args.date, // user-selected value / field / func
      { var: "Start_Unified_Sync_Time" }, // injected field
    ],
  }),

  sqlFunc: "UNIFIED_YEARS_BETWEEN",

  args: {
    date: {
      label: "From Date",
      type: "date",
      valueSources: ["value", "field", "func"],
    },
  },

  formatFunc: (formattedArgs) =>
    `UNIFIED_YEARS_BETWEEN(${formattedArgs.date}, Start_Unified_Sync_Time)`,

  sqlFormatFunc: (formattedArgs) =>
    `UNIFIED_YEARS_BETWEEN(${formattedArgs.date}, Start_Unified_Sync_Time)`,
};

export default UNIFIED_YEARS_BETWEEN;
